import { Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination } from '@mui/material'
import React, { useContext, useEffect, useState, useMemo, useRef } from 'react'
import templateStyles from '../../../../../../assets/styles/componentStyles/templatemessages.module.scss'
import globalStyles from '../../../../../../assets/styles/global.module.scss'
import feedbackStyles from "../../../../../../assets/styles/componentStyles/feedbackStyles/feedbackStyle.module.scss";
import { useNavigate, useSearchParams } from 'react-router-dom'
import { UserContext, UserContextPayload } from '../../../../../../context/userContext'
import { IntegrationContext, IntegrationContextPayload } from '../../../../../../context/integrationContext'
import { formatDateTime, getValueOrDefault, getWabaName, hasTemplateManageAccess, isAdmin, isValidWabaId } from '../../../../../../utils/constants'
import { getVendorField } from '../../../../../../utils/whiteLabelling'
import { whatsappTemplateLanguages } from '../../../../../../utils/whatsappTemplate'
import EmptyState from '../../../../../global/emptyState'
import emptyStateWhatsappTemplate from "../../../../../../assets/images/whatsapp/emptyWhatsappTemplateState.png";
import GlobalButton from '../../../../../utility/globalButton/button'
import IconsColor from '../../../../../utility/iconsColor'
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { getTemplateDetails, getTemplateLibraryDraftList, globalMenuItemData } from '../../../../../../models/axiosModel'
import MoreVertIcon from '@mui/icons-material/MoreVert';
import dashboardStyles from '../../../../../../assets/styles/componentStyles/callAnalysisStyles/callAnalysisDashboard.module.scss';
import { accountSetupBreadcrumb, channelsBreadcrumb, homeBreadcrumb, templateMessagesBreadcrumb } from '../../../../../../utils/breadcrumb'
import { GenericDataContext, GenericDataContextPayload } from '../../../../../../context/genericDataContext'
import { WhatsappTemplateContext, WhatsappTemplateContextPayload } from '../../../../../../context/whatsappTemplateContext'
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';
import { lightGreyColor, primaryColor } from '../../../../../../utils/colors'
import agent from '../../../../../../services/api'
import { getIntegrationChannelIdForCopyCurl, getTemplateQualityRating, getTemplateVariableDataForSendTemplateCurl, TEMPLATE_NAME_MAX_CHARS_FOR_TOOLTIP, TEMPLATE_QUALITY_RATING } from './utils'
import GlobalTooltip from '../../../../../utility/tooltip/globalTooltip'
import GlobalDeletePopup from '../../../../../utility/globalDeletePopup/globalDeletePopup'
import { WHATSAPP_TEMPLATE_STATUS } from './utils'
import { useTemplateLibraryStore } from '../../../../../../store/templateLibraryStore'
import { useGenericStore } from '../../../../../../store/genericStore'
import { useShallow } from 'zustand/react/shallow'
import { findWhatsAppIntegration } from '../../../../../../pages/ruleBasedInbox/utils'
import GlobalSearch from '../../../../../utility/GlobalSearch/GlobalSearch';
import useGenericHook from '../../../../../../hooks/useGenericHook';
import CopyToClipboardIcon from '../../../../../utility/copyToClipboardIcon/copyToClipboardIcon';
import GlobalMenu from '../../../../../globalMenu';

type TableRowItem = 
    | { isDraft: true; data: getTemplateLibraryDraftList }
    | { isDraft: false; data: getTemplateDetails };

const TemplateList = () => {
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const { setFlagLoading, handleError, apiRoutesPermissionAssignment, userDetail, vendorData } = useContext(UserContext) as UserContextPayload;
    
    const [anchorEl, setAnchorEl] = useState<null | SVGSVGElement>(null);
    const { getMetaIntegrationList, integrationListNewStructure, setIntegrationDetails } = useContext(IntegrationContext) as IntegrationContextPayload;
    const [menuRow, setMenuRow] = useState<TableRowItem | null>(null);
    const [draftToDelete, setDraftToDelete] = useState<getTemplateLibraryDraftList | null>(null);

    const { setBreadCrumbs } = React.useContext(GenericDataContext) as GenericDataContextPayload;
    const { templateList, getTemplateList, sortTemplateList } = useContext(WhatsappTemplateContext) as WhatsappTemplateContextPayload;
    
    const templateLibraryDraftList = useTemplateLibraryStore((state) => state.templateLibraryDraftList);
    const getTemplateLibraryDraftListApiCall = useTemplateLibraryStore((state) => state.getTemplateLibraryDraftListApiCall);
    const getWhatsappTemplateTypesApiCall = useTemplateLibraryStore((state) => state.getWhatsappTemplateTypesApiCall);
    const whatsappTemplateTypes = useTemplateLibraryStore((state) => state.whatsappTemplateTypes);
    const deleteDraftTemplate = useTemplateLibraryStore((state) => state.deleteDraftTemplate);

    const { showSuccess, showError } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess,
        showError: state.showError
    })))

    const [flagShowArchiveConfirmation, setFlagShowArchiveConfirmation] = useState<boolean>(false);
    const [selectedTemplate, setSelectedTemplate] = useState<getTemplateDetails | null>(null);
    
    const [isPageReady, setIsPageReady] = useState<boolean>(false);
    const [isDraftReady, setIsDraftReady] = useState<boolean>(false);
    const [isTemplateReady, setIsTemplateReady] = useState<boolean>(!searchParams.has('id'));
    const isPageReadyRef = useRef(isPageReady);

    const [page, setPage] = useState<number>(0);
    const [rowsPerPage, setRowsPerPage] = useState<number>(50);
    const [searchTerm, setSearchTerm] = useState<string>("");

    let id = searchParams.get("id");
    const pathname = window.location.pathname.toLowerCase()
    const innerHeight = (window.innerHeight - 170);

    const { isScreenBelow600 } = useGenericHook();

    const getTemplateName = (jsonData: string): string => {
        try {
            const data = JSON.parse(jsonData);
            const templateData = Array.isArray(data?.whatsapp_template_data) ? data.whatsapp_template_data?.[0] : data?.whatsapp_template_data;
            return getValueOrDefault(templateData?.whatsapp_template_name || null);
        } catch {
            return "-";
        }
    };

    const getTemplateDisplayName = (jsonData: string): string => {
        try {
            const data = JSON.parse(jsonData);
            const templateData = Array.isArray(data?.whatsapp_template_data) ? data.whatsapp_template_data?.[0] : data?.whatsapp_template_data;
            return getValueOrDefault(templateData?.whatsapp_template_display_name || null);
        } catch {
            return "-";
        }
    };
    
    const getTemplateLanguage = (jsonData: string): string => {
        try {
            const data = JSON.parse(jsonData);
            const templateData = Array.isArray(data?.whatsapp_template_data) ? data.whatsapp_template_data?.[0] : data?.whatsapp_template_data;
            const languageData = templateData?.whatsapp_language_data?.whatsapp_language_name;
            if (languageData) return languageData;
            const languageId = templateData?.whatsapp_language_id;
            if (languageId != null) {
                const language = whatsappTemplateLanguages?.find((language: { whatsapp_language_id: number }) => language.whatsapp_language_id === languageId);
                return getValueOrDefault(language?.whatsapp_language_name);
            }
            return "-";
        } catch {
            return "-";
        }
    };

    const getTemplateType = (jsonData: string): string => {
        try {
            const data = JSON.parse(jsonData);
            const typeName = data?.whatsapp_template_type?.name;
            if (typeName) return typeName;
            const typeId = data?.whatsapp_template_type_id;
            if (typeId != null && whatsappTemplateTypes?.length) {
                const templateType = whatsappTemplateTypes.find((templateType: { whatsapp_template_type_id: number }) => templateType.whatsapp_template_type_id === typeId);
                return getValueOrDefault(templateType?.name);
            }
            return "-";
        } catch {
            return "-";
        }
    };

    const getUpdatedAtTimestampDraft = (row: getTemplateLibraryDraftList): string => {
        if (row.updated_at_timestamp) {
            return getValueOrDefault(formatDateTime(row.updated_at_timestamp, "dmyTime"));
        }
        return "-";
    };

    const getPaginatedTableData = (templates: TableRowItem[]) => {
        return templates?.slice((page * rowsPerPage), (page * rowsPerPage) + rowsPerPage);
    }

    const combinedTableData = useMemo<TableRowItem[] | null>(() => {

        if (!templateLibraryDraftList && !templateList) {
            return null;
        }

        const getDraftSortTimestamp = (row: TableRowItem): number => {
            if (!row.isDraft) return 0;
            try {
                const data = JSON.parse(row.data.json_data);
                const timestamp = data?.updated_at_timestamp ?? data?.created_at_timestamp;
                return timestamp ? new Date(timestamp).getTime() : 0;
            } catch {
                return 0;
            }
        };

        const drafts: TableRowItem[] = (templateLibraryDraftList ?? []).map((draft: getTemplateLibraryDraftList) => ({
            isDraft: true as const,
            data: draft,
        })).sort((a, b) => getDraftSortTimestamp(b) - getDraftSortTimestamp(a));

        const templates: TableRowItem[] = sortTemplateList(templateList ?? [])?.map((template: getTemplateDetails) => ({
            isDraft: false as const,
            data: template
        }))

        if(id === "" || id === null || id === undefined || !isValidWabaId(id, integrationListNewStructure)) {
            return [...drafts];
        }

        return [...drafts, ...templates];

    }, [templateLibraryDraftList, templateList]);

    const filteredTableData = useMemo<TableRowItem[] | null>(() => {
        if (!combinedTableData) return null;
        const term = searchTerm.trim().toLowerCase();
        if (!term) return combinedTableData;

        return combinedTableData.filter((row) => {
            if (row.isDraft) {
                const name = getTemplateName(row.data.json_data).toLowerCase();
                const displayName = getTemplateDisplayName(row.data.json_data).toLowerCase();
                const category = (row.data.whatsapp_template_category_name ?? "").toLowerCase();
                const language = getTemplateLanguage(row.data.json_data).toLowerCase();
                const templateType = getTemplateType(row.data.json_data).toLowerCase();
                return name.includes(term) || displayName.includes(term) || category.includes(term) || language.includes(term) || templateType.includes(term);
            } else {
                const templateData = row.data.whatsapp_template_data?.[0];
                const name = (templateData?.whatsapp_template_name ?? "").toLowerCase();
                const displayName = (templateData?.whatsapp_template_display_name ?? "").toLowerCase();
                const category = (templateData?.whatsapp_template_category_name ?? "").toLowerCase();
                const language = (templateData?.whatsapp_language_data?.whatsapp_language_name ?? "").toLowerCase();
                const status = (row.data.whatsapp_template_metadata?.meta_whatsapp_template_status_name ?? "").toLowerCase();
                const templateType = (row.data.whatsapp_template_type?.name ?? "-").toLowerCase();
                return name.includes(term) || displayName.includes(term) || category.includes(term) || language.includes(term) || status.includes(term) || templateType.includes(term);
            }
        });
    }, [combinedTableData, searchTerm]);

    const getTemplateListData = async (meta_integration_whatsapp_id: number, hideLoader = true) => {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
        try {
            const response = await getTemplateList(meta_integration_whatsapp_id)
            if (!response.status) {
                handleError(response);
            }
        } finally {
            if (hideLoader || isPageReadyRef.current) {
                setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
            }
        }
    }

    const getTemplateDetails = async (whatsapp_meta_integration_id: number, template_id: number) => {
        const response = await agent.getWhatsappTemplateDetails.get(whatsapp_meta_integration_id, template_id)
        if (response.status) {
            return response.data[0];
        }
        return null;
    }

    const handleTemplateFormattingToExport = (template: getTemplateDetails) => {
        return {
            ...template,
            meta_integration_whatsapp_id: null,
            whatsapp_template_id: null,
            whatsapp_template_metadata: null,
            quality_score: null,
        }
    }

    const handleCopyTemplateJSON = async (row: getTemplateDetails) => {

        const whatsapp_meta_integration_id = Number(row?.meta_integration_whatsapp_id);
        const template_id = Number(row?.whatsapp_template_id);

        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        try {
            const template = await getTemplateDetails(whatsapp_meta_integration_id, template_id);

            if (!template) {
                showError("Template not found!")
                return;
            }

            const formattedTemplate = handleTemplateFormattingToExport(template);
            const templateJson = JSON.stringify(formattedTemplate, null, 2);
            await navigator.clipboard.writeText(templateJson);
            showSuccess("Template JSON Copied to Clipboard Successfully!")
        } catch {
            showError("Unable to copy template JSON.")
        } finally {
            setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
        }
    }

    const handleCopySendTemplateCurl = async (row: getTemplateDetails) => {
        const template_id = Number(row?.whatsapp_template_id);
        const whatsapp_meta_integration_id = Number(row?.meta_integration_whatsapp_id);

        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        try {
            const res = await getTemplateDetails(whatsapp_meta_integration_id, template_id);

            if (!res) {
                showError("Template not found!")
                return;
            }

            const baseUrl = getVendorField(vendorData, "backend api", process.env.REACT_APP_BASE_URL);
            const templateVariableData = getTemplateVariableDataForSendTemplateCurl(res);
            const integratedChannelIdForCopyCurl = getIntegrationChannelIdForCopyCurl(integrationListNewStructure, whatsapp_meta_integration_id);
            const payload = {
                whatsapp_template_id: template_id,
                user_wa_phone_number: "{{insert user's phone number}}",
                integrated_channel_id: integratedChannelIdForCopyCurl,
                template_variable_data: templateVariableData
            };

            // Escape single quotes so the --data body stays valid in a single-quoted shell string
            const dataPayload = JSON.stringify(payload, null, 4).replace(/'/g, `'\\''`);

            const curl = [
                `curl --location '${baseUrl}/api/thread/send-wa-template' \\`,
                `--header 'Authorization: Bearer {{insert acess token or api key}}' \\`,
                `--header 'content-type: application/json' \\`,
                `--data '${dataPayload}'`
            ].join('\n');

            await navigator.clipboard.writeText(curl);
            showSuccess("Send Template cURL Copied to Clipboard Successfully!");
        } catch (err){
            showError("Unable to copy send template curl.");
            console.error("Unable to copy cURL", err);
        } finally {
            setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
        }
    }

    const handleExportTemplate = async (row: getTemplateDetails) => {

        const whatsapp_meta_integration_id = Number(row?.meta_integration_whatsapp_id);
        const template_id = Number(row?.whatsapp_template_id);

        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        try {
            const templateToExport = await getTemplateDetails(whatsapp_meta_integration_id, template_id);

            if (!templateToExport) {
                showError("Template not found!")
                return;
            }
            
            const formattedTemplate = handleTemplateFormattingToExport(templateToExport);
            const currentTimeStamp = formatDateTime(new Date(), "dmyTimeFormatWithUnderscore");
            const domainName = window.location.hostname;
            const templateName = (row?.whatsapp_template_data?.[0]?.whatsapp_template_display_name
                ?? row?.whatsapp_template_data?.[0]?.whatsapp_template_name
                ?? "template");
            
            const fileName = `${domainName}_${templateName}_${currentTimeStamp}.json`;
            const fileContent = JSON.stringify(formattedTemplate, null, 2);

            const blob = new Blob([fileContent], { type: "application/json" });
            const downloadUrl = URL.createObjectURL(blob);
            const link = document.createElement("a");

            link.href = downloadUrl;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(downloadUrl);

            showSuccess("Template Exported Successfully!")
        } catch {
            showError("Unable to export template JSON.")
        } finally {
            setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
        }
    }

    useEffect(() => {
        isPageReadyRef.current = isPageReady;
    }, [isPageReady]);

    useEffect(() => {
        if (isDraftReady && isTemplateReady) {
            setIsPageReady(true);
            setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }));
        }
    }, [isDraftReady, isTemplateReady]);

    useEffect(() => {
        (async () => {
            setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
            try {
                const [draftRes, typesRes] = await Promise.all([
                    getTemplateLibraryDraftListApiCall(),
                    getWhatsappTemplateTypesApiCall(),
                ]);

                if (!(draftRes?.status)) {
                    handleError(draftRes);
                }
                if (!(typesRes?.status)) {
                    handleError(typesRes);
                }
                if (!integrationListNewStructure) {
                    const res = await getMetaIntegrationList(true)
                    if (!(res.status)) {
                        handleError(res);
                    }
                }
            } finally {
                setIsDraftReady(true);
            }
        })()
    }, []);

    useEffect(() => {
        (async () => {
            if (searchParams.has('id')) {
                if (integrationListNewStructure && integrationListNewStructure.length > 0) {
                    let id = searchParams.get('id')
                    let integration = findWhatsAppIntegration(integrationListNewStructure, id ?? '');
                    
                    if (integration) {
                        let whatsapp_meta_integration_id = integration.meta_integration_whatsapp_id
                        setIsTemplateReady(false);
                        await getTemplateListData(whatsapp_meta_integration_id, false)
                        setIntegrationDetails(integration)
                    }
                    setIsTemplateReady(true);
                } else if (integrationListNewStructure !== null && integrationListNewStructure.length === 0) {
                    setIsTemplateReady(true);
                }
            } else {
                setIntegrationDetails(null)
                setIsTemplateReady(true);
            }
        })()
    }, [integrationListNewStructure])

    useEffect(() => {
        if (id) {
            const updatedBreadcrumbs = [
                homeBreadcrumb,
                { ...channelsBreadcrumb },
                // { name: getWabaName(integrationListNewStructure, searchParams.get('id')), path: `/channels/viewintegration/Whatsapp?id=${id}`, isActive: false, isSamePageRedirecting: pathname === "/channels/viewintegration/whatsapp" },
                { name: getWabaName(integrationListNewStructure, Number(searchParams.get('id')), "Whatsapp"), path: `/channels/viewintegration/Whatsapp?id=${id}`, isActive: false, isSamePageRedirecting: pathname === "/channels/viewintegration/whatsapp" },
                { ...templateMessagesBreadcrumb, isActive: true },
            ];
            setBreadCrumbs(updatedBreadcrumbs);
        } else {
            setBreadCrumbs([homeBreadcrumb, { ...channelsBreadcrumb }, { ...accountSetupBreadcrumb, isActive: true }]);
        }
    }, [id, integrationListNewStructure])

    const columns = [
        { field: 'whatsapp_template_display_name', headerName: 'Template Display Name', width: 200 },
        { field: 'whatsapp_template_name', headerName: 'Meta Template Name', width: 200 },
        { field: 'whatsapp_template_category', headerName: 'Category', width: 150 },
        { field: 'whatsapp_language', headerName: 'Language', width: 150 },
        { field: 'whatsapp_template_type', headerName: 'Template Type', width: 120 },
        { field: 'whatsapp_template_status', headerName: 'Status', width: 120 },
        { field: 'quality_score', headerName: 'Quality Rating', width: 120 },
        { field: 'flag_allow_tracking', headerName: 'Tracking Enabled', width: 150 },
        { field: 'updated_at_timestamp', headerName: 'Last Updated', width: 150 },
        { field: '', headerName: '', width: 30, zIndex: 5 },
    ];

    const selectedTemplateForMenu = menuRow && !menuRow.isDraft ? menuRow.data : null;

    const getTemplateStatusName = (row: getTemplateDetails) => {
        return getMetaStatusOfTemplate(row.whatsapp_template_flag_interactive_message, row.whatsapp_template_metadata?.meta_whatsapp_template_status_name)?.status;
    };

    const isSelectedTemplateApproved = selectedTemplateForMenu
        ? getTemplateStatusName(selectedTemplateForMenu)?.toLowerCase() === WHATSAPP_TEMPLATE_STATUS['APPROVED']?.toLowerCase()
        : false;

    const menuItem: globalMenuItemData[] = [
        {
            type: "item",
            label: "Make a Copy",
            icon: <ContentCopyIcon sx={{ color: lightGreyColor, fontSize: "18px" }} />,
            isDisable: !hasTemplateManageAccess(apiRoutesPermissionAssignment, userDetail),
            onClick: (row: getTemplateDetails) => {
                navigate(`/channels/viewintegration/whatsapp/templatelibrary/modifyTemplate?id=${id}&copy_template=${row?.whatsapp_template_id}`)
            }
        },
        {
            type: "item",
            label: "Archive",
            icon: <ArchiveOutlinedIcon sx={{ color: lightGreyColor, fontSize: "20px" }} />,
            isDisable: !hasTemplateManageAccess(apiRoutesPermissionAssignment, userDetail) || !isSelectedTemplateApproved,
            onClick: (row: getTemplateDetails) => {
                setSelectedTemplate(row);
                setFlagShowArchiveConfirmation(true);
            }
        },
        {
            type: "item",
            label: "Export Template",
            icon: <FileUploadOutlinedIcon sx={{ color: lightGreyColor, fontSize: "20px" }} />,
            isDisable: !isSelectedTemplateApproved,
            onClick: (row: getTemplateDetails) => {
                handleExportTemplate(row);
            }
        },
        {
            type: "item",
            label: "Copy Template JSON",
            icon: <ContentCopyIcon sx={{ color: lightGreyColor, fontSize: "18px" }} />,
            isDisable: !isSelectedTemplateApproved,
            onClick: (row: getTemplateDetails) => {
                handleCopyTemplateJSON(row);
            }
        },
        ...(isAdmin(userDetail) ? [
            {
                type: 'item',
                label: "Copy Send Template cURL",
                icon: <ContentCopyIcon sx={{ color: lightGreyColor, fontSize: "18px" }} />,
                isDisable: !isSelectedTemplateApproved,
                onClick: (row: getTemplateDetails) => handleCopySendTemplateCurl(row)
            }
        ] as globalMenuItemData[] : [])
    ]

    const archiveTemplate = async () => {
        if(selectedTemplate){
            const whatsapp_template_id = selectedTemplate?.whatsapp_template_id;
            const meta_integration_whatsapp_id = Number(selectedTemplate?.meta_integration_whatsapp_id);

            setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
            const res = await agent.archiveTemplate.delete(whatsapp_template_id, meta_integration_whatsapp_id);
            if(!(res.status)){
                handleError(res);
            } else {
                showSuccess("Template Archived Successfully")
                await getTemplateListData(meta_integration_whatsapp_id)
            }
            setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
        }
    }

    const menuItemDraft: globalMenuItemData[] = [
        {
            type: "item",
            label: "Delete",
            icon: <IconsColor iconName="DeleteIcon" height="16" width="16" fillColor="#1A1A1A" />,
            isDisable: !hasTemplateManageAccess(apiRoutesPermissionAssignment, userDetail),
            onClick: (row: getTemplateLibraryDraftList) => {
                setDraftToDelete(row);
            }
        }
    ]

    const handleDeleteDraftConfirm = async () => {
        if (draftToDelete?.whatsapp_template_draft_id) {
            setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
            const response = await deleteDraftTemplate(draftToDelete.whatsapp_template_draft_id);
            if (response.status) {
                showSuccess("Draft Deleted Successfully!")
                setDraftToDelete(null);
            } else {
                handleError(response);
            }
            setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
        }
    }

    const draftTemplateName = draftToDelete ? getTemplateDisplayName(draftToDelete.json_data) : "Untitled";

    const handleMenuOpen = (event: React.MouseEvent<SVGSVGElement, MouseEvent>, row: TableRowItem) => {
        event.stopPropagation();
        event.preventDefault();
        setMenuRow(row);
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setMenuRow(null);
        setAnchorEl(null);
    };

    const handleRowClick = (row: TableRowItem) => {
        // const data = row.isDraft ? JSON.parse(row?.data?.json_data) : row.data;

        // // const flagInteractive = data?.whatsapp_template_flag_interactive_message;
        // // const templateTypeName = data?.whatsapp_template_type?.name?.toLowerCase();
        // // const isCarousel = templateTypeName === TEMPLATE_TYPES['CAROUSEL']?.toLowerCase();

        const queryParam = row.isDraft ? `draft_id=${row.data.whatsapp_template_draft_id}` : `template_id=${row.data.whatsapp_template_id}`;

        navigate(`/channels/viewintegration/whatsapp/templatelibrary/modifyTemplate?id=${id}&${queryParam}`);

        // if(!flagInteractive && !isCarousel){
        //     navigate(`/channels/viewintegration/whatsapp/templatelibrary/modifyTemplate?id=${id}&${queryParam}`);
        // } else {
        //     navigate(`/channels/viewintegration/whatsapp/legacy/templateinfo?id=${id}&${queryParam}`);
        // }
    }

    function getMetaStatusOfTemplate(isTemplateInteractive: boolean | undefined, status: string | undefined) {
        if (isTemplateInteractive) {
            return {
                status: "Approved",
                className: 'approvedButtonStyle'
            }
        } else {
            switch (status?.toLowerCase()) {
                case 'approved':
                    return {
                        status: "Approved",
                        className: 'approvedButtonStyle'
                    }
                case 'draft':
                    return {
                        status: 'Draft',
                        className: "draftButtonStyle"
                    }
                case 'pending':
                    return {
                        status: 'Pending',
                        className: "pendingButtonStyle"
                    }
                default:
                    return {
                        status: 'Rejected',
                        className: "rejectedButtonStyle"
                    }
            }
        }
    }

    const hasValidTemplateQualityRating = (score: string | undefined) => {
        return (score && score != TEMPLATE_QUALITY_RATING["UNKNOWN"]);
    }

    const renderTableRow = (row: TableRowItem, ind: number) => {
        const isDraft = row.isDraft;
        const templateName = isDraft ? getTemplateName(row.data.json_data) : (row.data.whatsapp_template_data?.[0]?.whatsapp_template_name ?? "-");
        const templateDisplayName = isDraft ? getTemplateDisplayName(row.data.json_data) : (row.data.whatsapp_template_data?.[0]?.whatsapp_template_display_name ?? "-");
        const category = isDraft ? (row.data.whatsapp_template_category_name ?? "-") : (row.data.whatsapp_template_data?.[0]?.whatsapp_template_category_name ?? "-");
        const language = isDraft ? getTemplateLanguage(row.data.json_data) : (row.data.whatsapp_template_data?.[0]?.whatsapp_language_data?.whatsapp_language_name ?? "-");
        const templateType = isDraft ? getTemplateType(row.data.json_data) : (row.data.whatsapp_template_type?.name ?? "-");
        const status = isDraft ? "Draft" : getMetaStatusOfTemplate(row.data.whatsapp_template_flag_interactive_message, row.data.whatsapp_template_metadata?.meta_whatsapp_template_status_name)?.status ?? "-";
        const statusClassName = isDraft ? "draftButtonStyle" : getMetaStatusOfTemplate(row.data.whatsapp_template_flag_interactive_message, row.data.whatsapp_template_metadata?.meta_whatsapp_template_status_name)?.className;
        const qualityScore = isDraft ? "-" : (row.data?.quality_score?.score ?? "-");
        const tracking = isDraft ? "-" : (row.data?.flag_allow_tracking?.toString() ?? "-");
        const lastUpdated = isDraft ? getUpdatedAtTimestampDraft(row.data) : (row.data.updated_at_timestamp ? formatDateTime(row.data.updated_at_timestamp, "dmyTime") : "-");
        const rowKey = isDraft ? (row.data.whatsapp_template_draft_id ?? ind) : row.data.whatsapp_template_id;

        return <React.Fragment key={isDraft ? `draft-${rowKey}` : `template-${rowKey}`}>
            <TableRow className={`${templateStyles.tableBodyRow}`} onClick={() => handleRowClick(row)} style={{ cursor: "pointer" }}>
                <TableCell className={`${templateStyles.tableBodyCell} ${templateStyles.templateListTableCellMinWidth200} ${templateStyles.templateName}`}>
                    <div className={templateStyles.valueWithCopyIcon}>
                        <GlobalTooltip title={templateDisplayName?.length > TEMPLATE_NAME_MAX_CHARS_FOR_TOOLTIP ? templateDisplayName : ""} placement="right-start">
                            <span className={templateStyles.templateNameText}>{templateDisplayName}</span>
                        </GlobalTooltip>
                        
                        {templateDisplayName !== "-" && (
                            <CopyToClipboardIcon
                                text={templateDisplayName}
                                label="Template Display Name"
                                className={templateStyles.copyToClipboardIconContainer}
                                iconClassName={templateStyles.copyToClipboardIcon}
                            />
                        )}
                    </div>
                </TableCell>
                <TableCell className={`${templateStyles.tableBodyCell} ${templateStyles.templateListTableCellMinWidth200} ${templateStyles.templateName}`}>
                    <div className={templateStyles.valueWithCopyIcon}>
                        <GlobalTooltip title={templateName?.length > TEMPLATE_NAME_MAX_CHARS_FOR_TOOLTIP ? templateName : ""} placement="right-start">
                            <span className={templateStyles.templateNameText}>{templateName}</span>
                        </GlobalTooltip>

                        {templateName !== "-" && (
                            <CopyToClipboardIcon
                                text={templateName}
                                label="Meta Template Name"
                                className={templateStyles.copyToClipboardIconContainer}
                                iconClassName={templateStyles.copyToClipboardIcon}
                            />
                        )}
                    </div>
                </TableCell>
                <TableCell className={`${templateStyles.tableBodyCell} ${templateStyles.templateListTableCellMinWidth150}`}>{category}</TableCell>
                <TableCell className={`${templateStyles.tableBodyCell} ${templateStyles.templateListTableCellMinWidth150}`}>{language}</TableCell>
                <TableCell className={`${templateStyles.tableBodyCell} ${templateStyles.templateListTableCellMinWidth120}`}>{templateType}</TableCell>
                {/* @ts-ignore */}
                <TableCell className={`${templateStyles.tableBodyCell} ${templateStyles.templateListTableCellMinWidth120}`}><span className={globalStyles[statusClassName ?? ""]}>{status}</span></TableCell>
                <TableCell className={`${templateStyles.tableBodyCell} ${templateStyles.templateListTableCellMinWidth120}`}>
                    <Grid container gap={1} className={globalStyles.displayFlex}>
                        {hasValidTemplateQualityRating(qualityScore) && 
                            <Grid item className={templateStyles.qualityRatingIcon} sx={{ backgroundColor: `${qualityScore?.toLowerCase()}` }}></Grid>
                        }
                        <Grid item>
                            {getTemplateQualityRating(qualityScore)}
                        </Grid>
                    </Grid>
                </TableCell>
                <TableCell className={`${templateStyles.tableBodyCell} ${templateStyles.templateListTableCellMinWidth150}`}>{tracking}</TableCell>
                <TableCell className={`${templateStyles.tableBodyCell} ${templateStyles.templateListTableCellMinWidth150}`}>{lastUpdated}</TableCell>
                <TableCell className={`${dashboardStyles.tableBodySubHeadingFontStyle} ${templateStyles.tableBodyCell} ${templateStyles.stickyTemplateTableLastColumn}`} onClick={(e) => e.stopPropagation()}>
                    <MoreVertIcon
                        sx={{ cursor: "pointer" }}
                        onClick={(e: React.MouseEvent<SVGSVGElement, MouseEvent>) => handleMenuOpen(e, row)}
                    />
                </TableCell>
            </TableRow>
        </React.Fragment>
    }
    const handleCreateWhatsappTemplate = () => {
        const integration_id = searchParams.get('id')
        navigate(`/channels/viewintegration/whatsapp/templatelibrary?id=${integration_id}`)
    }

    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(e.target.value);
        setPage(0);
    }

    return (
        <>
            <Grid item xs={12} paddingBlock={2}>
                {isPageReady && combinedTableData && combinedTableData.length > 0 ?
                    <>
                        <Grid container className={`${globalStyles.flexColumn} ${globalStyles.gapTwo}`}>
                            <Grid item>
                                <Grid container className={`${globalStyles.displayFlex} ${isScreenBelow600 ? '' : globalStyles.contentEnd}`}>
                                    <Grid item>
                                        <GlobalSearch
                                            fullWidth
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => { handleSearch(e) }}
                                            size="small"
                                            placeholder="Search Template Message"
                                            className={templateStyles.searchbar}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item className={globalStyles.fullwidth}>
                                <TableContainer className={`${templateStyles.tableContainer} ${globalStyles.WritewizGlobaltable} ${globalStyles.relativePosition}`}>
                                    <Table aria-label='simple table'>
                                        <TableHead className={`${templateStyles.tableHead} ${templateStyles.stickyTemplateTableHeader}`}>
                                            <TableRow className={templateStyles.tableHeadRow}>
                                                {columns?.map((column, ind) =>
                                                    <TableCell key={ind} className={`${templateStyles.tableHeadCell} ${globalStyles.clickable} ${globalStyles.relativePosition} ${column?.headerName?.length == 0 ? templateStyles.stickyTemplateTableHeaderLastColumn : ''}`} sx={{ minWidth: `${column.width}px`, zIndex: column?.zIndex }}>
                                                        <Grid container direction={"row"} flexWrap={"nowrap"} alignItems={"center"} gap={1}>
                                                            <Grid item>
                                                                {column.headerName}
                                                            </Grid>
                                                            {column?.headerName?.toLowerCase() == "quality rating" && 
                                                                <GlobalTooltip
                                                                    title='Every template has a quality rating based on usage, customer feedback, and engagement.'
                                                                    placement='top'
                                                                    arrow
                                                                >
                                                                    <span className={globalStyles.displayFlex}>
                                                                        <IconsColor fillColor={primaryColor} iconName="info" height={"14"} width={"14"} />
                                                                    </span>
                                                                </GlobalTooltip>
                                                            }
                                                        </Grid>
                                                    </TableCell>
                                                )}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody className={`${templateStyles.tableBody} ${globalStyles.fullwidth}`}>
                                            {getPaginatedTableData(filteredTableData ?? [])?.length > 0 ? 
                                                getPaginatedTableData(filteredTableData ?? []).map((row, ind) => renderTableRow(row, ind))
                                                :
                                                <TableRow className={dashboardStyles.cellRow}>
                                                    <TableCell colSpan={12} className={globalStyles.textCenter}>
                                                        No Data Available
                                                    </TableCell>
                                                </TableRow>
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>

                            {filteredTableData && filteredTableData?.length > 0 && 
                                <Grid item className={globalStyles.textItemsEnd}>
                                    <Grid container className={globalStyles.contentEnd}>
                                        <Grid item className={templateStyles.tablePaginationGrid}>
                                            <TablePagination
                                                component="div"
                                                className={`${feedbackStyles.feedbackTablePaginationStyle} ${templateStyles.tablePagination}`}
                                                count={filteredTableData?.length}
                                                rowsPerPageOptions={[10, 25, 50, 100, 1000]}
                                                page={page}
                                                rowsPerPage={rowsPerPage}
                                                onRowsPerPageChange={(e) => setRowsPerPage(parseInt(e.target.value))}
                                                onPageChange={(e, newPage) => setPage(newPage)}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            }
                        </Grid>
                    </>
                    :
                    <>
                        {isPageReady && filteredTableData?.length === 0 &&
                            <EmptyState
                                height={`${innerHeight}px !important`}
                                maxHeight={`${innerHeight}px !important`}
                                pageIcon={<img alt="chatbot" src={emptyStateWhatsappTemplate} style={{ width: "165px", height: "auto" }} />}
                                pageSubText={"No Template Created Yet! Start With a New Template"}
                                primaryActionBtn={<GlobalButton
                                    buttonText={"Template"}
                                    sx={{ width: "130px" }}
                                    className='primaryButtonStyle'
                                    onClick={handleCreateWhatsappTemplate}
                                    startIcon={<IconsColor iconName="plus" width="15px" height="15px" fillColor="#fff" />}
                                />}
                            />
                        }
                    </>
                }
            </Grid>

            <GlobalMenu
                anchorEl={anchorEl}
                handleMenuClose={handleMenuClose}
                menuItemData={menuRow ? (menuRow.isDraft ? menuItemDraft : menuItem) : []}
                open={Boolean(anchorEl)}
                additionalField={menuRow?.data}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            />

            {flagShowArchiveConfirmation && 
                <GlobalDeletePopup
                    deleteDescription={`Are you sure you want to archive this template`}
                    title={'Archive Confirmation'}
                    deleteNote={'Once archived, this template cannot be restored.'}
                    primaryButtonText={'Archive'}
                    open={flagShowArchiveConfirmation}
                    onClose={() => { setFlagShowArchiveConfirmation(false) }}
                    onDelete={() => {
                        archiveTemplate()
                        setFlagShowArchiveConfirmation(false)
                    }}
                />
            }

            {draftToDelete && (
                <GlobalDeletePopup
                    title={'Delete Draft Confirmation'}
                    deleteDescription={`Are you sure you want to delete the draft template named "${draftTemplateName}"`}
                    primaryButtonText={'Delete'}
                    deleteNote={'Once deleted, this draft cannot be restored.'}
                    open={draftToDelete}
                    onClose={() => setDraftToDelete(null)}
                    onDelete={handleDeleteDraftConfirm}
                />
            )}
        </>
    )
}

export default TemplateList
